<template>
    <Modal :visible="visible" backdrop>
        <template v-slot:main>
            <SottoProgettoForm
                @saved="$emit('saved', $event)"
                :defaultValue="defaultValue"
                @chiudi="$emit('chiudi')"
                :id="id"
                :progetto_id="progetto_id"
                :progetto_is_promo="progetto_is_promo"
                :create="create"
                :cliente_id="cliente_id"
            ></SottoProgettoForm>
        </template>
    </Modal>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Modal from "@/components/Modal.vue";
import MultiselectOption from "@/components/MultiselectOption.vue";
import NextButton from "@/components/NextButton.vue";
import Field from "@/components/Field.vue";
import SottoProgettoForm from "@/components/SottoProgettoForm.vue";

@Options({
    name:'ModalSottoProgetto',
    components: {
        SottoProgettoForm,
        Field,
        Modal,
        NextButton,
        MultiselectOption,
    },
    props: {
        visible: {
            type: Boolean,
            default: true
        },
        cliente_id: {
            type: [Number, String],
            required: false
        },
        defaultValue: {
            type: Object,
            default: {}
        },

        id: {
            type: [Number, String],
            default: 0
        },
        progetto_id: {
            type: [Number, String],
            default: 0
        },
        progetto_is_promo: {
            type: Boolean,
            default: false
        },
        create: {
            type: Boolean,
            default: true
        }
    }
})
export default class ModalSottoProgetto extends Vue {
    cliente_id!: number | string
    id!: number | string

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
